export const style = {
  wrapper: {
    padding: `15px 0`
  },
  formGroup: {
    margin: `10px 0`
  },
  input: {
    color: `#555`,
    fontSize: `14px`,
    padding: `0 12px`,
    border: `#e6e6e6 2px solid`,
    borderRadius: 0,
    ':focus': {
      borderColor: `#c6c6c6`
    }
  },
  inputError: {
    borderColor: `#a94442`
  },
  singleRowInput: {
    height: `38px`
  },
  submit: {
    fontSize: `15px`,
    fontWeight: 300,
    opacity: 0.8,
    color: `white`,
    padding: `8px 25px`,
    width: `100%`,
    background: `#AD5251`,
    border: `#AD5251 2px solid`,
    cursor: `pointer`,
    transition: `0.2ss`,
    ':hover': {
      opacity: 1
    },
    ':focus': {
      background: `white`,
      color: `#AD5251`
    }
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Register/style/form.js